<template>
  <marketing-section-wrapper
    title="Ready to transform your workflow?"
    subtitle="Join thousands of engineers using StructEngine for accurate, code-compliant designs"
    section-class="final-cta-section"
    @visible="handleCtaVisible"
  >
    <div class="cta-actions">
      <!-- Logged-in users see Dashboard button -->
      <se-button
        v-if="isAuthenticated"
        variant="primary"
        style-set="set5"
        @click="handleDashboardClick"
      >
        Go to Dashboard
        <v-icon end>mdi-view-dashboard</v-icon>
      </se-button>

      <!-- Non-logged-in users see Create Account button -->
      <se-button
        v-else
        variant="primary"
        style-set="set5"
        @click="handleRegisterClick"
      >
        Create My Free Account
        <v-icon end>mdi-rocket-launch</v-icon>
      </se-button>

      <se-button
        variant="secondary"
        style-set="set5"
        @click="handleDemoClick"
      >
        Watch Demo
        <v-icon end>mdi-play</v-icon>
      </se-button>
    </div>
  </marketing-section-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SeButton from '@/components/SEButton.vue'
import MarketingSectionWrapper from './MarketingSectionWrapper.vue'
import { useAuthStore } from '@/stores/auth'

const emit = defineEmits<{
  ctaVisible: [visible: boolean]
  navigateTo: [path: string]
}>()

// Auth state
const authStore = useAuthStore()
const isAuthenticated = computed(() => authStore.isAuthenticated)

// Event handlers
const handleCtaVisible = (visible: boolean) => {
  if (visible) {
    if (import.meta.env.DEV) console.log('CTA section visible')
    emit('ctaVisible', visible)
  }
}

const handleRegisterClick = () => {
  emit('navigateTo', '/login')
}

const handleDashboardClick = () => {
  emit('navigateTo', '/dashboard')
}

const handleDemoClick = () => {
  window.open('https://www.youtube.com/watch?v=tW29HdkudqA', '_blank', 'noopener,noreferrer')
}
</script>

<style scoped>
.final-cta-section {
  padding: 4rem 0;
  background: var(--bg-surface);
  border-top: 1px solid var(--border-subtle);
  border-bottom: 1px solid var(--border-subtle);
  position: relative;
  overflow: hidden;
}

.cta-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

/* SVG icon sizing - fix massive default size */
.cta-actions svg {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
}

/* Responsive design */
@media (max-width: 767px) {
  .final-cta-section {
    padding: 3rem 0;
  }

  .cta-actions {
    flex-direction: column;
    gap: 16px;
  }

  .cta-actions :deep(.se-btn) {
    width: 100%;
    max-width: 300px;
  }
}
</style>
